import { ApiClient } from 'ApiClient';
import { Experience } from 'interfaces';

class ExperienceService {
  public async getAll(): Promise<Experience[]> {
    return ApiClient.get<Experience[]>('experiences');
  }

  public async getById(id: number): Promise<Experience> {
    return ApiClient.get<Experience>(`experiences/${id}`);
  }

  /**
   * Create with optional banner file. Uses multipart so the API's
   * BucketWrapper upload path works the same as gallery image upload.
   */
  public create(data: any) {
    return ApiClient.post('experiences', data);
  }

  public update(id: number, data: any) {
    return ApiClient.put(`experiences/${id}`, data);
  }

  /**
   * Upload a banner image for an existing experience. Separate endpoint
   * because PUT can't carry multipart in the current ApiClient — text
   * fields go via update(), the file goes here.
   */
  public updateBanner(id: number, file: File) {
    return ApiClient.post(`experiences/${id}/banner`, { image: file });
  }

  public remove(id: number) {
    return ApiClient.delete(`experiences/${id}`);
  }
}

const singleton = new ExperienceService();
export { singleton as ExperienceService };
